import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-video-card-2',
  templateUrl: 'video-card-2.component.html'
})
export class VideoCard2Component {

  @Input() setting: any;
  @Input() item: any;

}
